import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {AppLoader} from '..';
import PublicSessionsCardList from './components/PublicSessionsCardList';
import PublicCoachesList from './components/PublicCoachesList';
import useQuery from '../../hooks/useQuery';

/**
 * 2 sided view sessions | coaches -> public page
 * 1 side view session -> loggedin user
 */
const PublicAppointments = () => {
  const authDetails = useSelector(state => state.auth);
  const publicUser = useSelector(state => state.publicUser);
  const bookingDetails = useSelector(state => state.booking);
  const sessionIdUrlQuery = useQuery().get('sessionId');
  const branchIdUrlQuery = useQuery().get('branchId');
  const trainerIdUrlQuery = useQuery().get('trainerId');
  const [servicesList, setServicesList] = useState({
    list: [],
    isLoading: true,
  });
  const [trainerList, setTrainerList] = useState([]);
  const [selectedService, setSelectedService] = useState({});
  useEffect(() => {
    if (!authDetails.companyData) return;
    const isLoggedIn = Boolean(authDetails.authDetails);
    const requestedServiceId = sessionIdUrlQuery || (!isLoggedIn && publicUser?.sessionId);
    const branchId =
      branchIdUrlQuery ||
      (isLoggedIn ? authDetails.companyData?.branch?.id : publicUser?.branchSelected?.id);
    const companyTrainers = Object.values(authDetails.companyData?.trainers?.items || {});
    const services = (authDetails.companyData?.services?.service || [])
      .filter(service => !sessionIdUrlQuery || service.uuid === sessionIdUrlQuery)
      .map(service => {
        const assignments = service.selectedTrainers || [];
        const trainers = companyTrainers.length
          ? companyTrainers.filter(trainer =>
              assignments.some(
                assignment =>
                  assignment.branchTrainersTrainerId === trainer.branchTrainersTrainerId &&
                  (!assignment.branchTrainersBranchId ||
                    assignment.branchTrainersBranchId === trainer.branchTrainersBranchId)
              )
            )
          : assignments;
        return {
          service,
          trainer: trainers.filter(
            trainer =>
              (!branchId || trainer.branchTrainersBranchId === branchId) &&
              (!trainerIdUrlQuery || trainer.branchTrainersTrainerId === trainerIdUrlQuery) &&
              trainer.availability !== false
          ),
        };
      });
    const selected = services.find(
      ({service}) =>
        service.uuid === (requestedServiceId || (isLoggedIn && bookingDetails.service?.uuid))
    );
    setServicesList({list: services, isLoading: false});
    setSelectedService(selected?.service || {});
    setTrainerList(selected?.trainer || []);
  }, [
    authDetails.companyData,
    authDetails.authDetails,
    publicUser?.sessionId,
    publicUser?.branchSelected?.id,
    sessionIdUrlQuery,
    branchIdUrlQuery,
    trainerIdUrlQuery,
    bookingDetails.service?.uuid,
  ]);

  return authDetails.companyDataLoadingStatus || servicesList?.isLoading ? (
    <AppLoader />
  ) : (
    <div className="select_coach">
      <div className="page-wrap row">
        <div className="page-content col-12">
          <section className="amazing_feature">
            <div className="col-12 row">
              <div className="col-12 col-lg-8">
                <h2 className="heading mt-4 mb-4 font-size-20 text-uppercase text-center border-bottom pb-2">
                  Services
                </h2>
                <PublicSessionsCardList
                  servicesList={servicesList.list}
                  setTrainerList={setTrainerList}
                  setSelectedService={setSelectedService}
                  selectedService={selectedService}
                />
              </div>

              {!authDetails?.authDetails &&
                servicesList?.list?.length > 0 &&
                Object.keys(selectedService)?.length > 0 && (
                  <div className="col-12 col-lg-4">
                    <h2 className="heading mt-4 mb-4 font-size-20 text-uppercase text-center border-bottom pb-2">
                      Coaches
                    </h2>
                    <PublicCoachesList
                      trainerList={trainerList}
                      selectedService={selectedService}
                    />
                  </div>
                )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PublicAppointments;
